export function mathRoundDecimal (x, decimals = 1) {
  let multiplier = Math.pow(10, decimals)
  return Math.round(x * multiplier) / multiplier
}